import React, { useEffect } from "react";

import { useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import { Box, Divider, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import CustomDropzone from "../../../../../components/CustomDropzone";
import { RadioOptions } from "../../RadioOptions";
import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";
import FileInformation from "../../../../../components/FileInformation";

export const PossuiIdentidade = ({
  anexoEditado,
  setAnexoEditado,
  props,
  dataMenor,
  dataFutura,
  dataNascimento,
  scrollToField,
  idAnexo,
  idTipoPendencia,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Group
      border={
        idAnexo === "3" || ["13", "14", "15"].includes(idTipoPendencia)
          ? "3px solid #4299E199"
          : ""
      }
      scrollToField={
        idAnexo === "3" || ["13", "14", "15"].includes(idTipoPendencia)
          ? scrollToField
          : null
      }
    >
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499"
      >
        IDENTIDADE
      </Text>
      <Divider mb="5" />
      <RadioOptions
        label="Possui Identidade?*"
        fieldName="possuiIdentidade"
        errors={errors}
        touched={touched}
      />
      {values.possuiIdentidade === "S" && (
        <Grid
          mt="15px"
          templateColumns="repeat(5, 1fr)"
          gap="25px"
          rowGap="20px"
        >
          <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }}>
            <CustomInputWField
              whiteSpace={true}
              fieldName="numeroIdentidade"
              label="Número da Identidade*"
              placeholder="Informe o Número da Identidade"
            />
          </GridItem>

          <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
            <CustomInputWField
              whiteSpace={true}
              fieldName="orgaoExpedidor"
              label="Órgão Expedidor"
              placeholder="Informe o Órgão Expedidor"
            />
          </GridItem>
          <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
            <CustomDatepickerWField
              fieldName="dataExpedicaoIdentidade"
              label="Data da Expedição"
              placeholder="DD/MM/AAAA"
              maxDate={new Date()}
            />
            {dataMenor &&
              dataNascimento &&
              props.values.dataExpedicaoIdentidade && (
                <Text
                  mt="8px"
                  color="#E53E3E"
                  fontSize="sm"
                  lineHeight={"normal"}
                >
                  Data de expedição menor que a data de nascimento.
                </Text>
              )}

            {dataFutura && props.values.dataExpedicaoIdentidade && (
              <Text
                mt="8px"
                color="#E53E3E"
                fontSize="sm"
                lineHeight={"normal"}
              >
                A data informada não pode ser uma data futura!
              </Text>
            )}
          </GridItem>
        </Grid>
      )}
      <Grid
        display={"flex"}
        flexDirection={{ base: "column", lg: "row" }}
        mt="25px"
        templateColumns="repeat(4, 1fr) 1fr"
        gap="25px"
      >
        {values.possuiIdentidade === "S" && (
          <>
            <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
              {anexoEditado || !values.originalIdentidade ? (
                <Flex>
                  <CustomDropzone
                    whiteSpace={true}
                    formProps={{ setFieldValue }}
                    title="Anexar Identidade"
                    fieldName="identidade"
                    setAnexoNaoEditado={
                      values.originalIdentidade
                        ? () => {
                            setAnexoEditado(false);
                          }
                        : null
                    }
                    height="42px"
                  />
                </Flex>
              ) : (
                values.originalIdentidade && (
                  <FileInformation
                    label="Anexar Identidade"
                    name={values.originalIdentidade.nomeArquivo}
                    path={values.originalIdentidade.path
                      .toString()
                      .split("/")
                      .pop()}
                    setAnexoEditado={() => {
                      setAnexoEditado(true);
                    }}
                    isVisualizacao={false}
                    height="42px"
                    width={"216px"}
                  />
                )
              )}
            </GridItem>
          </>
        )}

        <GridItem colSpan={{ base: 2, sm: 3, lg: 1 }}>
          <Box width={{ lg: "450.48px" }}>
            <CustomInputWField
              whiteSpace={true}
              fieldName="numeroSolicitacaoIdentidade"
              label="Número de solicitação do documento ao órgão responsável"
              placeholder="Informe o Número de Solicitação"
            />
          </Box>
        </GridItem>
      </Grid>
    </Group>
  );
};
